import type { MouseEvent as ReactMouseEvent } from 'react'
import { MenuItem } from '@mui/material'

import AccentLabel, {
  type AccentLabelProps,
} from '~/components/common/labels/AccentLabel'

export interface AccentSelectItemProps extends AccentLabelProps {
  classes?: any
  onClick?: (event: ReactMouseEvent<any>) => void
}

export const StylableAccentSelectItem = ({
  classes,
  onClick,
  ...rest
}: AccentSelectItemProps) => (
  <MenuItem onClick={onClick}>
    <AccentLabel {...rest} classes={classes} />
  </MenuItem>
)
